/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InformReasonArrivalAliases {
  AUTOCOMPLETE_REASON = 'autocomplete-reason',
  CONTEXTUAL_BAR_REASON = 'contextual-bar-reason',
  FETCH_REASON = 'fetch-reason',
  FIELD_REASON = 'field-reason',
  FIELD_REASON_TEXT = 'field-reason-text',
  FORM_REASON = 'form-reason',
  LAYOUT_REASON = 'layout-reason',
  MAPPER_REASON = 'mapper-reason',
  PANEL_REASON = 'panel-reason',
  TEXT_AREA_REASON = 'text-area-reason',
  TEXT_REASON = 'text-reason',
}
export { InformReasonArrivalAliases };
